var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarbonSendAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56_9765)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.91875 6.09167C-0.75492 5.3554 -0.352185 4.69802 0.223498 4.22718C0.79918 3.75634 1.51369 3.49995 2.25 3.5H21.75C22.4863 3.49995 23.2008 3.75634 23.7765 4.22718C24.3522 4.69802 24.7549 5.3554 24.9187 6.09167L12 14.19L-0.91875 6.09167ZM-1 7.995V19.835L8.42988 13.905L-1 7.995ZM9.98663 14.8833L-0.689625 21.595C-0.425844 22.1655 -0.00951922 22.6474 0.510895 22.9846C1.03131 23.3219 1.63441 23.5006 2.25 23.5H21.75C22.3655 23.5001 22.9684 23.321 23.4885 22.9835C24.0086 22.6459 24.4246 22.1639 24.688 21.5933L14.0118 14.8817L12 16.1433L9.98663 14.8817V14.8833ZM15.5701 13.9067L25 19.835V7.995L15.5701 13.905V13.9067Z",
    fill: "#23A6F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_9765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 26,
    fill: "white",
    transform: "translate(0 0.375)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonSendAlt);
export default __webpack_public_path__ + "static/media/carbon_send-alt.ef4da554104ac8560b42d2559a3ce8a0.svg";
export { ForwardRef as ReactComponent };